import { useDevCycleClient } from '@devcycle/react-client-sdk';
import { useCallback } from 'react';
import { trackUser } from '@/analytics';
import { getConfig } from '@/constants/config';
import { syncDevCycleFlagsToPostHog } from '@/integrations/devcyclePosthogSync';
import { reportException } from '@/utils/error';

const useIdentifyUser = () => {
  const devCycleClient = useDevCycleClient();

  return useCallback(
    async (id: string) => {
      try {
        trackUser(id);
        await devCycleClient.identifyUser({
          user_id: id,
          // ISO 3166-1 alpha-2 for flag targeting (our UK market uses GB).
          country: getConfig().isoCountryCode,
        });
        // Values may be unchanged by identify (no variableUpdated), so sync explicitly to write person properties.
        syncDevCycleFlagsToPostHog(devCycleClient);
      } catch (error) {
        reportException(error, { level: 'warning' });
      }
    },
    [devCycleClient],
  );
};

export default useIdentifyUser;
